import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/feature/ScrollToTop";
import LiveChatWidget from "./components/feature/LiveChatWidget";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider } from "./contexts/ThemeContext";

function AppContent() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith('/canlidestek');
  return (
    <>
      <ScrollToTop />
      <AppRoutes />
      {!isAdminPage && <LiveChatWidget />}
    </>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <div className="w-full" style={{ overflowX: 'hidden', maxWidth: '100vw' }}>
              <AppContent />
            </div>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;